// extracted by mini-css-extract-plugin
export var caption = "ReviewCard-module--caption--6cfc9";
export var card = "ReviewCard-module--card--a79c3";
export var cardTop = "ReviewCard-module--cardTop--23d7a";
export var clutchIcon = "ReviewCard-module--clutchIcon--b973c";
export var clutchLink = "ReviewCard-module--clutchLink--24cd6";
export var companyLink = "ReviewCard-module--companyLink--bedc4";
export var fadeInAnimation = "ReviewCard-module--fadeInAnimation--c024c";
export var link = "ReviewCard-module--link--193b4";
export var linkedinIcon = "ReviewCard-module--linkedinIcon--27f98";
export var name = "ReviewCard-module--name--62af2";
export var photo = "ReviewCard-module--photo--f6cab";
export var position = "ReviewCard-module--position--b7b60";
export var text = "ReviewCard-module--text--1da02";
export var textWrapper = "ReviewCard-module--textWrapper--7fce5";